import { render, staticRenderFns } from "./AdvisorSettlementList.vue?vue&type=template&id=10800ec9&"
import script from "./AdvisorSettlementList.vue?vue&type=script&lang=js&"
export * from "./AdvisorSettlementList.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorSettlementList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports